module.exports = global["$"] = require("-!/var/www/bebe-au-naturel.com/node_modules/expose-loader/index.js?jQuery!./jquery.js");